import Examination from './Examination.vue';

export * from './types';
export default Examination;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/examination/index.ts